export const SUCCESS_MESSAGE_CODE = 1001;
export const VALIDATION_MESSAGE_CODE = 2001;
export const NOT_FOUND_CODE = 4001;
export const NOT_AVAILABLE_CODE = 4002;
